<!--Logo-->
<div class="py-4 text-center" style="background-color: white; height: 25%">
  <img class="logo-img" src="../../../../assets/images/logo_v2/gabadoo_logo_v2.png" alt="Gabadoo Logo">
</div>

<!--MAIN CONTAINER-->
<div class="container py-12">
  <!--  LOGIN CARD-->
  <mat-card class="login-card">
    <form [formGroup]="signUpForm" >
      <div style="width: 70%; margin: 0 auto; margin-bottom: 8%">
        <mat-card-content >
          <!--    Firstname-->
          <mat-form-field>
            <mat-label>First Name</mat-label>
            <input type="text" class="login-input" matInput formControlName="firstName" placeholder="Jack">
            <mat-error *ngIf="firstName.invalid && firstName.touched">
              Please enter a valid first name
            </mat-error>
          </mat-form-field>
          <br>
          <!--    Lastname-->
          <mat-form-field>
            <mat-label>Last Name</mat-label>
            <input type="text" class="login-input" matInput formControlName="lastName" placeholder="Smith">
            <mat-error *ngIf="lastName.invalid && lastName.touched">
              Please enter a valid last name
            </mat-error>
          </mat-form-field>
          <br>
          <!--    Username/Email-->
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input type="email" class="login-input" matInput formControlName="email" placeholder="pat@example.com">
            <mat-error *ngIf="email.invalid && email.touched">
              Please enter a valid email address
            </mat-error>
          </mat-form-field>
          <br>

          <!--    Country-->
          <mat-form-field *ngIf="!isTherapistSignup">
            <mat-label>Country</mat-label>
            <mat-select formControlName="country">
              <mat-option>Please select your Country of Residence</mat-option>
              <mat-option *ngFor="let country of countries" [value]="country">
                {{country | titlecase}}
              </mat-option>
            </mat-select>
            <br>
          </mat-form-field>

          <!--    Password-->
          <mat-form-field class="login-password-field">
            <mat-label>Password</mat-label>
            <input class="login-input" matInput [type]="hide ? 'password' : 'text'" formControlName="password">
            <mat-error *ngIf="password.invalid && password.touched">
              Please enter a valid password.
            </mat-error>
            <button mat-icon-button matSuffix style="outline: none" (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <div style="padding-bottom: 20px">
            <mat-label>Your password must contain:</mat-label>
            <div style="display: flex; flex-direction: column; margin-left: 20px">
              <mat-label>Minimum 8 characters</mat-label>
              <mat-label>At least one number</mat-label>
              <mat-label>At least one uppercase letter</mat-label>
              <mat-label>At least one lowercase letter</mat-label>
              <mat-label>At least one special letter</mat-label>
            </div>
          </div>


          <!--    Confirm - Password-->
          <mat-form-field class="login-password-field">
            <mat-label>Confirm Password</mat-label>
            <input class="login-input" matInput [type]="hide2 ? 'password' : 'text'" formControlName="confirmPasswordFormControl">
            <mat-error *ngIf="confirmPasswordFormControl.invalid && confirmPasswordFormControl.touched">
              Please confirm your password
            </mat-error>
            <button mat-icon-button matSuffix style="outline: none" (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
              <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
          </mat-form-field>
          <mat-error *ngIf="signUpForm.errors?.invalid && password.valid && confirmPasswordFormControl.touched">
            Passwords must match
          </mat-error>

          <!-- Checkbox for Privacy-->
          <mat-checkbox [ngModelOptions]="{standalone: true}" [(ngModel)]="isChecked">
          </mat-checkbox>
          <span style="font-size: 0.8rem; font-weight: bold">
            I have read and agree to Gabadoo's
            <a class="privacy-link" (click)="openPrivacyDialog(templatePrivacyDialog)">Privacy Policy</a> and
            <a class="privacy-link" (click)="openTermsServiceDialog(templateTermsDialog)">Terms of Service</a>
          </span>

        </mat-card-content>
      </div>

      <!--    Login button-->
      <div style="margin: 6% auto">
        <button mat-raised-button align
                class="btn-material-primary button-align"
                [disabled]="signUpForm.invalid || !isChecked"
                (click)="onSignupSubmit(templateSignupComplete)"
        >Create Account
        </button>
      </div>
    </form>

    <!--    Break -->
    <hr class="login-hr-break">
    <!--    Log in-->
    <div style="margin: 5% auto">
      <button mat-raised-button align (click)="onSignIn()" class="btn-material-secondary secondary-btn-align login-btn">
        Already have an account? Click Here</button>
    </div>
  </mat-card>
</div>


<!--Policy-->
<ng-template #templatePrivacyDialog>
  <h1 style="text-align: center" mat-dialog-title>Privacy Policy</h1>
  <mat-dialog-content class="mat-typography">
    <p>
      This Privacy Policy describes how Gabadoo (the “Site” or “we”) collects, uses, and discloses your Personal Information when you visit or make a purchase from the Site.
    </p>
    <!--    Collecting Personal Information-->
    <div>
      <h2>Collecting Personal Information</h2>
      <p>When you visit the Site, we collect certain information about your device, your interaction with the Site, and
        information necessary to process your purchases. We may also collect additional information if you contact us for
        customer support. In this Privacy Policy, we refer to any information that can uniquely identify an individual
        (including the information below) as “Personal Information”. See the list below for more information about what
        Personal Information we collect and why.
      </p>

      <div>
        <h3 class="privacy-policy-header">Device information</h3>
        <ul>
          <li><span class="privacy-policy-list-header">Examples of Personal Information collected:</span> version of web browser, IP address,
            time zone, cookie information, what sites or products you view, search terms, and how you interact with the Site.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Purpose of collection:</span> to load the Site accurately for you, and to perform
            analytics on Site usage to optimise our Site.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Source of collection:</span> Collected automatically when you access our Site using
            cookies, log files, web beacons, tags, or pixels.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Disclosure for a business purpose:</span> shared with our processor Amazon Web Services
            (AWS) and Shopify aswell as SendInBlue to to store and manage emails.
          </li>
          <br>
        </ul>
      </div>

      <div>
        <h3 class="privacy-policy-header">Customer support information</h3>
        <ul>
          <li><span class="privacy-policy-list-header">Examples of Personal Information collected:</span> Your Email is only used to make contact with you.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Purpose of collection:</span> To provide customer support.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Source of collection:</span> Collected from you.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Disclosure for a business purpose:</span> Communication and Marketing purposes
          </li>
          <br>
        </ul>
      </div>


      <div>
        <h3 class="privacy-policy-header">Gabadoo services information</h3>
        <ul>
          <li><span class="privacy-policy-list-header">Examples of Personal Information collected:</span> Your Email is only used to make contact with you, we use your country so we can ensure you are getting support from a professional registered in your region.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Purpose of collection:</span> to provide services offered by Gabadoo
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Source of collection:</span> collected from you.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Disclosure for a business purpose:</span> The information you provide to us is used to match you with one of our Gabadoo Experts who will provide you with support. All Gabadoo Experts follow strict data protection protocols.
          </li>
          <br>
        </ul>
      </div>


    </div>
    <!--    Collecting Personal Information-->

    <!--    MINORS -->
    <div>
      <h2>MINORS</h2>
      <p>To provide support to families and children, information is needed so the experts on Gabadoo can make an
        assessment on how provide you with support. You have full control of the information you provide to us and you
        only need to provide information you are comfortable in providing e.g videos, images, text.
      </p>

      <div>
        <ul>
          <li><span class="privacy-policy-list-header">Examples of Personal Information collected:</span> Child's Name,
            Age, Typical day, Motivators, Siblings, Family Structure etc.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Purpose of collection:</span> to provide support from our developmental experts.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Source of collection:</span> collected from you.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Disclosure for a business purpose:</span> Information about your child is only used to provide our services and is not used for any purpose outside of this. The developmental experts on our platform and senior management, when necessary, are the only ones with access to this information and it is stored on secure AWS servers
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Medical Record Regulations:</span>As with any healthcare service, we must follow regulations for the storage of Medical Records. Any Gabadoo review you submit or Gaba Plan you receive must be stored by Gabadoo Limited for a period of 7 years and all GDPR regulations are abided by.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Research:</span> To improve our services on Gabadoo, and to improve services globally, Gabadoo Limited may use anonymised information for research purposes. The type of anonymised information that may be gathered may include your child's age, gender, country of residence, race, the reason you are looking for support or any diagnosis they may have. There will never be identifiable personal information shared with any parties outside of Gabadoo without your written permission.
          </li>
          <br>
          <li><span class="privacy-policy-list-header">Access to your child's information:</span>We closely guard who has access to your child's information. Only the expert who completes your Gabadoo Review has access to all of the information you provided about your child.
          </li>
          <br>
        </ul>
      </div>
    </div>
    <!--    MINORS -->

    <!--    Sharing Personal Information -->
    <div>
      <h1>Sharing Personal Information</h1>
      <p>We share the account owners Personal Information with service providers to help us provide our services and
        fulfill our contracts with you, as described above. For example:
      </p>
      <div>
        <ul>
          <li>We use Shopify to power our website. You can read more about how Shopify uses your Personal Information here: https://www.shopify.com/legal/privacy.
          </li>
          <br>
          <li>We may share your Personal Information to comply with applicable laws and regulations, to respond to a subpoena, search warrant or other lawful request for information we receive, or to otherwise protect our rights.
          </li>
          <br>
          <li>We use Google Analytics to help us understand how our users use the Site -- you can read more about how Google uses your Personal Information here: https://www.google.com/intl/en/policies/privacy/. You can also opt-out of Google Analytics here: https://tools.google.com/dlpage/gaoptout.
          </li>
          <br>
        </ul>
      </div>

      <h2>BEHAVIOURAL ADVERTISING</h2>
      <p>As described above, we use the account owners Personal Information to provide you with targeted advertisements
        or marketing communications we believe may be of interest to you. For example:
      </p>
      <div>
        <ul>
          <li>We use Google Analytics to help us understand how our customers use the Site. You can read more about how Google uses your Personal Information here:
            <a href="https://policies.google.com/privacy?hl=en">https://policies.google.com/privacy?hl=en.</a> You can also opt-out of Google Analytics here:
            <a href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout.</a>
          </li>
          <br>
          <li>We share information about your use of the Site, your purchases, and your interaction with our ads on other websites with our advertising partners. We collect and share some of this information directly with our advertising partners, and in some cases through the use of cookies or other similar technologies (which you may consent to, depending on your location).
          </li>
          <br>
        </ul>
      </div>
      <p>For more information about how targeted advertising works, you can visit the Network Advertising Initiative’s (“NAI”) educational page at
        <a href="http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work">http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work</a>.
      </p>
      <br>
      <p>
        You can opt out of targeted advertising by:
      </p>
      <div>
        <ul>
          <li>FACEBOOK - <a href="https://www.facebook.com/settings/?tab=ads">https://www.facebook.com/settings/?tab=ads</a>
          </li>
          <br>
          <li>GOOGLE - <a href=" https://www.google.com/settings/ads/anonymous"> https://www.google.com/settings/ads/anonymous</a>
          </li>
          <br>
        </ul>
        <p>
          Additionally, you can opt out of some of these services by visiting the Digital Advertising Alliance’s opt-out portal at:
          <a href="http://optout.aboutads.info/.">http://optout.aboutads.info/.</a>
        </p>
      </div>
    </div>
    <!--    Sharing Personal Information -->

    <!--    Using Personal Information -->
    <div>
      <h2>Using Personal Information</h2>
      <p>
        We use your personal Information to provide our services to you.
      </p>
      <br>
      <p>The personal information on your Gabadoo account is not shared or provided to any third party outside
        of which is mentioned within this privacy policy.
      </p>
      <br>
      <p>All personal information you have provided is only used to provide services to you through Gabadoo.</p>
      <br>

      <h3>LAWFUL BASIS</h3>

      <p>
        Pursuant to the General Data Protection Regulation (“GDPR”), if you are a resident of the European Economic Area (“EEA”), we process your personal information under the following lawful bases:
      </p>

      <ul>
        <li>Your consent;</li>
        <li>The performance of the contract between you and the Site;</li>
        <li>Compliance with our legal obligations;</li>
        <li>To protect your vital interests;</li>
        <li>To perform a task carried out in the public interest;</li>
        <li>For our legitimate interests, which do not override your fundamental rights and freedoms.</li>
      </ul>

      <h3>AUTOMATIC DECISION-MAKING</h3>

      <p>
        If you are a resident of the EEA, you have the right to object to processing based solely on automated decision-making (which includes profiling), when that decision-making has a legal effect on you or otherwise significantly affects you.
      </p>
      <br>
      <p>
        If you are a resident of the EEA, you have the right to object to processing based solely on automated decision-making (which includes profiling), when that decision-making has a legal effect on you or otherwise significantly affects you.
      </p>
      <br>
      <p>
        If you are a resident of the EEA, you have the right to object to processing based solely on automated decision-making (which includes profiling), when that decision-making has a legal effect on you or otherwise significantly affects you.
      </p>

      <br>

      <p>
        Services that include elements of automated decision-making include:
      </p>

      <ul>
        <li>Temporary denylist of IP addresses associated with repeated failed transactions. This denylist persists for a small number of hours.
        </li>
        <li>Temporary denylist of IP addresses associated with repeated failed transactions. This denylist persists for a small number of hours.
        </li>
      </ul>

      <h3>GDPR</h3>

      <p>
        If you are a resident of the EEA, you have the right to access the Personal Information we hold about you,
        to port it to a new service, and to ask that your Personal Information be corrected, updated, or erased. If you would like to exercise these rights, please contact us through the contact information below.
      </p>
      <br>
      <p>
        Your Personal Information will be initially processed in Ireland and then will be transferred outside of Europe
        for storage and further processing, including to Canada and the United States. Only the information about the
        account holder is transferred outside of EU, information about a child is not processed outside of the EU.
        For more information on how data transfers comply with the GDPR, see Shopify’s GDPR Whitepaper: <a href="https://help.shopify.com/en/manual/your-account/privacy/GDPR">https://help.shopify.com/en/manual/your-account/privacy/GDPR.</a>
      </p>
      <br>
    </div>
    <!--    Using Personal Information -->

    <!--    Cookies -->
    <div>
      <h2>Cookies</h2>
      <p>
        A cookie is a small amount of information that’s downloaded to your computer or device when you visit our Site. We use a number of different cookies, including functional, performance, advertising, and social media or content cookies. Cookies make your browsing experience better by allowing the website to remember your actions and preferences (such as login and region selection). This means you don’t have to re-enter this information each time you return to the site or browse from one page to another. Cookies also provide information on how people use the website, for instance whether it’s their first time visiting or if they are a frequent visitor.
      </p>
      <br>
      <p>We use the following cookies to optimise your experience on our Site and to provide our services.
      </p>
      <br>

      <h3>COOKIES NECESSARY FOR THE FUNCTIONING OF THE STORE</h3>

      <table>
        <tr>
          <th>Name</th>
          <th>Function</th>
        </tr>
        <tr>
          <td>_ab</td>
          <td>Used in connection with access to admin.</td>
        </tr>

        <tr>
          <td>_secure_session_id</td>
          <td>Used in connection with navigation through a storefront.</td>
        </tr>

        <tr>
          <td>cart</td>
          <td>Used in connection with shopping cart.</td>
        </tr>

        <tr>
          <td>cart_sig</td>
          <td>Used in connection with checkout.</td>
        </tr>

        <tr>
          <td>cart_ts</td>
          <td>Used in connection with checkout.</td>
        </tr>

        <tr>
          <td>checkout_token</td>
          <td>Used in connection with checkout.</td>
        </tr>

        <tr>
          <td>secret</td>
          <td>Used in connection with checkout.</td>
        </tr>

        <tr>
          <td>secure_customer_sig</td>
          <td>Used in connection with customer login.
          </td>
        </tr>

        <tr>
          <td>storefront_digest</td>
          <td>Used in connection with customer login.</td>
        </tr>

        <tr>
          <td>_shopify_u</td>
          <td>Used to facilitate updating customer account information.</td>
        </tr>

      </table>


      <h3>REPORTING AND ANALYTICS</h3>

      <table>
        <tr>
          <th>Name</th>
          <th>Function</th>
        </tr>
        <tr>
          <td>_tracking_consent	</td>
          <td>Tracking preferences.</td>
        </tr>

        <tr>
          <td>_landing_page</td>
          <td>Track landing pages</td>
        </tr>

        <tr>
          <td>_orig_referrer</td>
          <td>Track landing pages</td>
        </tr>

        <tr>
          <td>_s</td>
          <td>Shopify analytics.</td>
        </tr>

        <tr>
          <td>_shopify_fs</td>
          <td>Shopify analytics.</td>
        </tr>

        <tr>
          <td>_shopify_s</td>
          <td>Shopify analytics.</td>
        </tr>

        <tr>
          <td>_shopify_sa_p</td>
          <td>Shopify analytics relating to marketing & referrals.</td>
        </tr>

        <tr>
          <td>_shopify_sa_t</td>
          <td>Shopify analytics relating to marketing & referrals.
          </td>
        </tr>

        <tr>
          <td>_shopify_y</td>
          <td>Shopify analytics.</td>
        </tr>

        <tr>
          <td>_y</td>
          <td>Shopify analytics.</td>
        </tr>
      </table>

      <p>
        The length of time that a cookie remains on your computer or mobile device depends on whether it is a “persistent” or “session” cookie. Session cookies last until you stop browsing and persistent cookies last until they expire or are deleted. Most of the cookies we use are persistent and will expire between 30 minutes and two years from the date they are downloaded to your device.
      </p>
      <br>
      <p>
        You can control and manage cookies in various ways. Please keep in mind that removing or blocking cookies can negatively impact your user experience and parts of our website may no longer be fully accessible
      </p>
      <br>
      <p>
        Most browsers automatically accept cookies, but you can choose whether or not to accept cookies through your browser controls, often found in your browser’s “Tools” or “Preferences” menu. For more information on how to modify your browser settings or how to block, manage or filter cookies can be found in your browser’s help file or through such sites as
        <a href="www.allaboutcookies.org.">www.allaboutcookies.org.</a>
      </p>
      <br>
      <p>
        Additionally, please note that blocking cookies may not completely prevent how we share information with third parties such as our advertising partners. To exercise your rights or opt-out of certain uses of your information by these parties, please follow the instructions in the “Behavioural Advertising” section above
      </p>

      <br>

      <h3>DO NOT TRACK</h3>

      <p>
        Please note that because there is no consistent industry understanding of how to respond to “Do Not Track” signals, we do not alter our data collection and usage practices when we detect such a signal from your browser.
      </p>
    </div>
    <!--    Cookies -->

    <!--    Changes -->
    <div>
      <h2>Changes</h2>
      <p>We may update this Privacy Policy from time to time in order to reflect, for example, changes to our practices or for other operational, legal, or regulatory reasons.
      </p>
    </div>
    <!--    Changes -->

    <!--    Contact -->
    <div>
      <h2>Contact</h2>
      <p>For more information about our privacy practices, if you have questions, or if you would like to make a complaint, please contact us by e-mail at
        <a href="support@gabadoo.com">support@gabadoo.com.</a>
      </p>
      <br>
      <p>
        Last updated: 24/08/2022
        If you are not satisfied with our response to your complaint, you have the right to lodge your complaint with the relevant data protection authority.
      </p>
    </div>
    <!--    Contact -->
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-template>

<!--Terms and Services-->
<ng-template #templateTermsDialog>
  <h1 style="text-align: center" mat-dialog-title>Terms of Service</h1>
  <mat-dialog-content class="mat-typography">
    <!--    The Terms of Service-->
    <div>
      <h3 class="privacy-policy-list-header">1. The Terms of Service</h3>
      <p>
        The following are the Terms of Service (the "Agreement") which govern your access and use of our online platform through which Allied Healthcare Services may be provided (collectively the "Platform"). This website is owned and operated by Gabadoo Limited. The Platform may be provided or be accessible via multiple websites or applications whether owned and/or operated by us or by third parties, including, without limitation, the website Gabadoo.com and its related apps.
      </p>
      <br>
      <p>
        By accessing or using the Platform, you are entering into this Agreement. You should read this Agreement carefully before starting to use the Platform. If you do not agree to be bound to any term of this Agreement, you must not access the Platform.
      </p>
      <br>
      <p>
        When the terms "we", "us", "our" or similar are used in this Agreement, they refer to any company that owns and operates the Platform (the "Company")
      </p>
      <br>
    </div>
    <!--    The Terms of Service-->

    <!--    The Allied Healthcare Professionals and Allied Healthcare Professional Services-->
    <div>
      <h3 class="privacy-policy-list-header">2.  The Allied Healthcare Professionals and Allied Healthcare Professional Services</h3>
      <p>
        The Platform may be used to connect you with an Allied Healthcare Professional who will provide services to you through the Platform (“Allied Healthcare Professional Services”).
      </p>
      <br>
      <p>
        For Irish and U.K. based Allied Healthcare Professionals
      </p>
      <br>
      <p>
        We require every Allied Healthcare Professional providing Allied Healthcare Professional Services on the Platform to be a qualified in the profession, registered with their regions governing body, insured and have a minimum of 2 years full-time post graduate experience.
      </p>
      <br>
      <p>
        The Allied Healthcare Professionals are independent providers who are neither our employees nor agents nor representatives. The Platform’s role is limited to enabling the Allied Healthcare Professional Services. The Allied Healthcare Professionals themselves are responsible for the performance of the Allied Healthcare Professional Services. If an Allied Healthcare Professional you have been connected with stops using the Platform at any time after you have been connected, we will send an email to notify you that your Allied Healthcare Professional is no longer on the Platform.
      </p>
      <br>
      <p>
        While we hope the Allied Healthcare Professional Services are beneficial to you, you understand, agree and acknowledge that they may not be the appropriate solution for everyone’s needs and that they may not be appropriate for every particular situation and/or may not be a complete substitute for a face-to-face examination and/or care in every particular situation.
      </p>
      <br>
      <p>
        THE PLATFORM IS NOT INTENDED FOR EMERGENCY PURPOSES OR THE PROVISION OF CLINICAL DIAGNOSIS REQUIRING AN IN-PERSON EVALUATION AND YOU SHOULD NOT USE IT IF YOU NEED ANY OFFICIAL DOCUMENTATION OR APPROVALS FOR PURPOSES SUCH AS, BUT NOT LIMITED TO, COURT-ORDERED ALLIED HEALTHCARE SERVICES. IT IS ALSO NOT INTENDED FOR ANY INFORMATION REGARDING WHICH DRUGS OR MEDICAL TREATMENT MAY BE APPROPRIATE FOR YOU OR YOUR CHILD, AND YOU SHOULD DISREGARD ANY SUCH ADVICE IF DELIVERED THROUGH THE PLATFORM.
      </p>
      <br>
    </div>
    <!--     The Allied Healthcare Professionals and Allied Healthcare Professional Services-->


    <!-- Privacy and Security -->
    <div>
      <h3 class="privacy-policy-list-header">3. Privacy and Security</h3>
      <p>
        Protecting and safeguarding any information you provide through the Platform is extremely important to us. Information about our security and privacy practices can be found on our Privacy Policy available at https://www.gabadoo.com/pages/privacy-policy (The ‘Privacy Policy’).
      </p>
      <br>
      <p>
        BY AGREEING TO THIS AGREEMENT AND/OR BY USING THE PLATFORM, YOU ARE ALSO AGREEING TO THE TERMS OF THE PRIVACY POLICY. THE PRIVACY POLICY IS INCORPORATED INTO AND DEEMED A PART OF THIS AGREEMENT. THE SAME RULES THAT APPLY REGARDING CHANGES AND REVISIONS OF THIS AGREEMENT ALSO APPLY TO CHANGES AND REVISIONS OF THE PRIVACY POLICY.
      </p>
      <br>
    </div>
    <!-- Privacy and Security-->


    <!--  Third Party Content-->
    <div>
      <h3 class="privacy-policy-list-header">4. Third Party Content</h3>
      <p>
        The Platform may contain other content, products or services which are offered or provided by third parties ("Third Party Content"), links to Third Party Content (including but not limited to links to other websites) or advertisements which are related to Third Party Content. We have no responsibility for the creation of any such Third Party Content, including (but not limited to) any related products, practices, terms or policies, and we will not be liable for any damage or loss caused by any Third Party Content.
      </p>
      <br>
    </div>
    <!--Third Party Content-->


    <!-- 5. Disclaimer of Warranty and Limitation of Liability -->
    <div>
      <h3 class="privacy-policy-list-header">5. Disclaimer of Warranty and Limitation of Liability</h3>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU HEREBY RELEASE US AND AGREE TO HOLD US HARMLESS FROM ANY AND ALL CAUSES OF ACTION AND CLAIMS OF ANY NATURE RESULTING FROM THE ALLIED HEALTHCARE PROFESSIONAL SERVICES OR THE PLATFORM, INCLUDING (WITHOUT LIMITATION) ANY ACT, OMISSION, OPINION, RESPONSE, ADVICE, SUGGESTION, INFORMATION AND/OR SERVICE OF ANY ALLIED HEALTHCARE PROFESSIONAL AND/OR ANY OTHER CONTENT OR INFORMATION ACCESSIBLE THROUGH THE PLATFORM.
      </p>
      <br>
      <p>
        YOU UNDERSTAND, AGREE AND ACKNOWLEDGE THAT THE PLATFORM IS PROVIDED "AS IS" WITHOUT ANY EXPRESS OR IMPLIED WARRANTIES OF ANY KIND, INCLUDING BUT NOT LIMITED TO MERCHANTABILITY, NON-INFRINGEMENT, SECURITY, FITNESS FOR A PARTICULAR PURPOSE OR ACCURACY. THE USE OF THE PLATFORM IS AT YOUR OWN RISK. TO THE FULLEST EXTENT OF THE LAW, WE EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND, WHETHER EXPRESSED OR IMPLIED.
      </p>
      <br>
      <p>
        YOU UNDERSTAND, AGREE AND ACKNOWLEDGE THAT WE SHALL NOT BE LIABLE TO YOU OR TO ANY THIRD PARTY FOR ANY INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, PUNITIVE OR EXEMPLARY DAMAGES.
      </p>
      <br>
      <p>
        YOU UNDERSTAND, AGREE AND ACKNOWLEDGE THAT OUR AGGREGATE LIABILITY FOR DAMAGES ARISING WITH RESPECT TO THIS AGREEMENT AND ANY AND ALL USE OF THE PLATFORM WILL NOT EXCEED THE TOTAL AMOUNT OF MONEY PAID BY YOU OR ON YOUR BEHALF THROUGH THE PLATFORM IN THE 12 MONTHS PERIOD PRIOR TO THE DATE OF THE CLAIM.
      </p>
      <br>
      <p>
        If the applicable law does not allow the limitation of liability as set forth above, the limitation will be deemed modified solely to the extent necessary to comply with applicable law.
      </p>
      <br>
      <p>
        This section (limitation of liability) shall survive the termination or expiration of this Agreement.
      </p>
      <br>
    </div>
    <!-- 5. Disclaimer of Warranty and Limitation of Liability -->


    <!-- Your Subscription -->
    <div>
      <h3 class="privacy-policy-list-header">6. Your Subscription</h3>
      <p>
        We offer different subscription options that you can choose. Any type of subscription you choose will continue and automatically renew until you cancel the membership. By choosing a recurring Membership Service, you acknowledge that such paid services have a recurring payment and you accept responsibility for all recurring charges prior to cancellation.
      </p>
      <br>
      <p>
        You can cancel the subscription to the service at any time for any reason. Your membership must be cancelled before it renews in order to avoid the next billing cycle.
      </p>
      <br>
      <p>
        We reserve the right to change our subscription or adjust prices of our services. Any changes to your membership services will only take effect following proper notice to you.
      </p>
      <br>
      <p>
        Free Trials: Occasionally, we offer free trials for our Services. Once a free trial expires, the paid membership will commence following a notice to you.
      </p>
      <br>
    </div>
    <!--    6. Your Subscription -->

    <!-- 7. Your account, representations, conduct and commitments -->
    <div>
      <h3 class="privacy-policy-list-header">7. Your account, representations, conduct and commitments</h3>
      <p>
        You hereby confirm that you are legally able to consent to receive Services, or have the consent of a parent or guardian, and are legally able to enter into a contract.
      </p>
      <br>
      <p>
        Minor Consent: Where consent from a parent or guardian is required to receive Services, you hereby confirm that as the consenting parent or guardian, you have the sole right to consent to Services for the minor seeking Allied Healthcare Services and are not legally mandated to confer with or get consent from any other legal guardian before consenting. You also give affirmative consent to the provisions set forth in the accompanying Privacy Policy regarding the collection, process, and use of personal information on behalf of the minor. You also agree that consent to Services remains valid until membership is cancelled.
      </p>
      <br>
      <p>
        You hereby confirm and agree that all the information that you provided in or through the Platform, and the information that you will provide in or through the Platform in the future, is accurate, true, current and complete. Furthermore, you agree that during the term of this Agreement you will make sure to maintain and update this information so it will continue to be accurate, current and complete.
      </p>
      <br>
      <p>
        You agree, confirm and acknowledge that you are responsible for maintaining the confidentiality of your password and any other security information related to your account (collectively "Account Access"). We advise you to change your password frequently and to take extra care in safeguarding your password.
      </p>
      <br>
      <p>
        You agree to notify us immediately of any unauthorised use of your Account Access or any other concern for breach of your account security.
      </p>
      <br>
      <p>
        You agree, confirm and acknowledge that we will not be liable for any loss or damage that incurred as a result of someone else using your account, either with or without your consent and/or knowledge.
      </p>
      <br>
      <p>
        You agree, confirm and acknowledge that you are solely and fully liable and responsible for all activities performed using your Account Access. You further acknowledge and agree that we will hold you liable and responsible for any damage or loss incurred as a result of the use of your Account Access by any person whether authorised by you or not, and you agree to indemnify us for any such damage or loss.
      </p>
      <br>
      <p>
        You agree and commit not to use the account or Account Access of any other person for any reason.
      </p>
      <br>
      <p>
        You agree and confirm that your use of the Platform, including the Allied Healthcare Professional Services, are for your own personal use only and that you are not using the Platform or the Allied Healthcare Professional Services for or behalf of any other person or organisation.
      </p>
      <br>
      <p>
        You agree and commit not to interfere with or disrupt, or attempt to interfere with or disrupt, any of our systems, services, servers, networks or infrastructure, or any of the Platform's systems, services, servers, networks or infrastructure, including without limitation obtaining unauthorized access to the aforementioned.
      </p>
      <br>
      <p>
        You agree and commit not to make any use of the Platform for the posting, sending or delivering of either of the following: (a) unsolicited email and/or advertisement or promotion of goods and services; (b) malicious software or code; (c) unlawful, harassing, privacy invading, abusive, threatening, vulgar, obscene, racist or potentially harmful content; (d) any content that infringes a third party right including intellectual property rights; (e) any content that may cause damage to a third party; (f) any content which may constitute, cause or encourage a criminal action or violate any applicable law.
      </p>
      <br>
      <p>
        You agree and commit not to violate any applicable local, state, national or international law, statute, ordinance, rule, regulation or ethical code in relation to your use of the Platform and your relationship with the Allied Healthcare Professionals and us.
      </p>
      <br>
      <p>
        If you receive any file from us or from a Allied Healthcare Professional, whether through the Platform or not, you agree to check and scan this file for any virus or malicious software prior to opening or using this file.
      </p>
      <br>
      <p>
        You will indemnify us, defend us, and hold us harmless from and against any and all claims, losses, causes of action, demands, liabilities, costs or expenses (including, but not limited to, litigation and reasonable attorneys' fees and expenses) arising out of or relating to any of the following: (a) your access to or use of the Platform; (b) any actions made with your account or Account Access whether by you or by someone else; (c) your violation of any of the provisions of this Agreement; (d) non-payment for any of the services (including Allied Healthcare Professional Services) which were provided through the Platform; (e) your violation of any third party right, including, without limitation, any intellectual property right, publicity, confidentiality, property or privacy right. This clause shall survive expiration or termination of this Agreement.
      </p>
      <br>
      <p>
        You confirm and agree to use only credit cards or other payment means (collectively “Payment Means”) which you are duly and fully authorized to use, and that all payment related information that you provided and will provide in the future, to or through the Platform, is accurate, current and correct and will continue to be accurate, current and correct.
      </p>
      <br>
      <p>
        You agree to pay all fees and charges associated with your Account on a timely basis and according to the fees schedule, the terms and the rates as published in the Platform. By providing us with your Payment Means you authorize us to bill and charge you through that Payment Means and you agree to maintain valid Payment Means information in your Account information.
      </p>
      <br>
    </div>
    <!--  7. Your account, representations, conduct and commitments -->

    <!--    Modifications, Termination, Interruption and Disruptions to the Platform-->
    <div>
      <h3 class="privacy-policy-list-header">8. Modifications, Termination, Interruption and Disruptions to the Platform</h3>
      <p>
        You understand, agree and acknowledge that we may modify, suspend, disrupt or discontinue the Platform, any part of the Platform or the use of the Platform, whether to all clients or to you specifically, at any time with or without notice to you. You agree and acknowledge that we will not be liable for any of the aforementioned actions or for any losses or damages that are caused by any of the aforementioned actions.
      </p>
      <br>
      <p>
        The Platform depends on various factors such as software, hardware and tools, either our own or those owned and/or operated by our contractors and suppliers. While we make commercially reasonable efforts to ensure the Platform’s reliability and accessibility, you understand and agree that no platform can be 100% reliable and accessible and so we cannot guarantee that access to the Platform will be uninterrupted or that it will be accessible, consistent, timely or error-free at all times.
      </p>
      <br>
    </div>
    <!--   Modifications, Termination, Interruption and Disruptions to the Platform-->

    <!--  Products-->
    <div>
      <h3 class="privacy-policy-list-header">9. Products</h3>
      <p>
        Products attached to a Gaba Plan that are recommended for a child are supplied by our product partner Thinking Toys. It is the responsibility of the person purchasing the product to ensure the product is suitable for their child. Some product can have multiple variations so it is your responsibility to check that the product is the correct one. Products are not manufactured, shipped or sold by Gabadoo Limited and any issues arising from products should be dealt with by you and Thinking Toys.
      </p>
      <br>
    </div>
    <!-- Products -->

    <!-- Notices -->
    <div>
      <h3 class="privacy-policy-list-header">10. Notices </h3>
      <p>
        We may provide notices or other communications to you regarding this agreement or any aspect of the Platform, by email to the email address that we have on record, by regular mail or by posting it online. The date of receipt shall be deemed the date on which such notice is given. Notices sent to us must be delivered by email to support@gabadoo.com.
      </p>
      <br>
    </div>
    <!-- Notices -->

    <!-- Important notes about our Agreement -->
    <div>
      <h3 class="privacy-policy-list-header">11. Important notes about our Agreement</h3>
      <p>
        This Agreement and our relationship with you shall both be interpreted solely in accordance with the laws of Ireland.
      </p>
      <br>
      <p>
        You irrevocably agree that the exclusive venue for any action or proceeding arising out of relating to this Agreement or our relationship with you, regardless of theory, shall be the Irish District. You irrevocably consent to the personal jurisdiction of the aforementioned courts and hereby waive any objection to the exercise of jurisdiction by the aforementioned courts. Nothing in this Agreement, including the choice of the laws of Ireland, affects your statutory rights as a consumer to rely on the mandatory consumer protection provisions contained in the law of the country in which you live.
      </p>
      <br>
      <p>
        THIS AGREEMENT CONSTITUTES THE ENTIRE AGREEMENT BETWEEN YOU AND US. YOU CONFIRM THAT YOU HAVE NOT RELIED UPON ANY PROMISES OR REPRESENTATIONS BY US EXCEPT AS SET FORTH IN THIS AGREEMENT.
      </p>
      <br>
      <p>
        We may change this Agreement by posting modifications on the Platform. Unless otherwise specified by us, all modifications shall be effective upon posting. Therefore, you are encouraged to check the terms of this Agreement frequently. The last update date of this Agreement is posted at the bottom of the Agreement. By using the Platform after the changes become effective, you agree to be bound by such changes to the Agreement. If you do not agree to the changes, you must terminate access to the Platform and participation in its services.
      </p>
      <br>
      <p>
        We may freely transfer or assign this Agreement or any of its obligations hereunder.
      </p>
      <br>
      <p>
        The paragraph headings in this Agreement are solely for the sake of convenience and will not be applied in the interpretation of this Agreement.
      </p>
      <br>
      <p>
        If any provision of this Agreement is held by a court of competent jurisdiction to be illegal, invalid, unenforceable, or otherwise contrary to law, the remaining provisions of this Agreement will remain in full force and effect.
      </p>
      <br>
      <p>
        To clear any doubt, all clauses regarding limitations of liabilities and indemnification shall survive the termination or expiration of this Agreement.
      </p>
      <p>Last Updated: 25/08/2022</p>
      <br>
    </div>
    <!-- Important notes about our Agreement -->
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #templateSignupComplete >
  <h1 mat-dialog-title>Account Verification</h1>
  <div mat-dialog-content>Please verify your account using the email we just sent you.</div>
  <div>
    <p>Check your spam/junk folder as it may go in there</p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
  </div>
</ng-template>
